PJQ.constants.sso = {
    providerNames: {
        AZURE_AD: "Azure Active Directory",
        OKTA: "Okta",
        ONELOGIN: "OneLogin",
        OTHER: "Other"
    },
    providers: {
        AZURE_AD: "AZURE_AD",
        OKTA: "OKTA",
        ONELOGIN: "ONELOGIN",
        OTHER: "OTHER"
    }
};

PJQ.models.sso = {};

PJQ.models.sso.Provider = PJQ.models.BaseModel.extend({
    idAttribute: 'id',
    endpoint: function () {
        let params = [];
        if (this.get('disableProvisioning')) {
            params.push({
                parameter: 'disableProvisioning',
                value: true
            });
        }

        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'settings'
            },
            {
                endpoint: 'saml',
                value: this.id
            }
        ], params)
    },
    getProviderName: function () {
        return PJQ.constants.sso.providerNames[this.get('provider')];
    },
    refreshProvisioningToken: function (callback) {
        if (this.id > 0) {
            new PJQ.ajax.Request({
                endpoint: this.endpoint() + "/refreshprovisioningtoken",
                type: 'POST',
                data: this.toJSON()
            }).post().done(_.bind(function (response) {
                if (typeof callback === 'function') {
                    let token = null;
                    if (_.size(response.provisioningToken) > 0) {
                        token = response.provisioningToken;
                        this.set('provisioningToken', token);
                    }
                    callback(token);
                }
            }, this)).fail(function () {
                if (typeof callback === 'function') {
                    callback(null);
                }
            });
        } else {
            let token = PJQ.helpers.guid();
            this.set('provisioningToken', token);
            callback(token);
        }
    },
    afterSave: function () {
        this.set('disableProvisioning', null);
    }
});

//Collections
PJQ.collections.sso = {};

PJQ.collections.sso.Providers = PJQ.collections.BaseCollection.extend({
    model: PJQ.models.sso.Provider,
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'settings'
            },
            {
                endpoint: 'saml'
            }
        ]);
    }
});

PJQ.views.settings.SSOSettings = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.SETTINGS, 'sso-settings')
    },
    events: {
        'click .btn-add-provider': 'addClicked',
        'click .btn-edit-provider': 'editClicked',
        'click .btn-delete-provider': 'deleteClicked'
    },
    beforeRender: function () {
    },
    renderData: function () {
        return {
            enablePermissions: this.options.enablePermissions
        };
    },
    afterRender: function () {
        this.dataTable = new PJQ.views.dataTables.DataTable({
            el: this.$(".sso-table"),
            data: this.collection.models,
            rowId: "id",
            order: [0, 'asc'],
            paging: false,
            language: {
                zeroRecords: "You haven't added any SSO providers yet"
            },
            onRowDoubleClick: _.bind(function (row) {
                this.editProvider(row.data());
            }, this),
            contextMenuOptions: {
                actions: [
                    {
                        name: 'Edit',
                        onClick: _.bind(function (row) {
                            this.editProvider(row.data());
                        }, this)
                    },
                    {
                        name: 'Delete',
                        isDanger: true,
                        onClick: _.bind(function (row) {
                            this.deleteProvider(row);
                        }, this)
                    }
                ]
            },
            columns: [
                {
                    "title": "Default",
                    "width": "100px",
                    "render": _.bind(function (data, type, row) {
                        let content = '';
                        if (row.get('isDefault')) {
                            content = '<i class="fs-16 text-dark far fa-check"</i>'
                        }
                        return content;
                    })
                },
                {
                    'title': "Provider",
                    "data": "attributes.provider",
                    "render": _.bind(function (data, type, row) {
                        return row.getProviderName();
                    })
                },
                {
                    "data": "",
                    "title": "",
                    "orderable": false,
                    "searchable": false,
                    "width": this.options.enablePermissions ? '160px' : '120px',
                    "render": _.bind(function (data, type, row) {
                        let buttons = '';
                        buttons += '<button type="button" title="Edit" class="btn btn-info btn-edit-provider mr-1"><span class="fal fa-pencil"></span></button>';
                        buttons += '<button type="button" title="Delete" class="btn btn-danger btn-delete-provider"><span class="fal fa-trash"></span></button>';
                        return '<div class="text-align-center show-on-row-hover">' + buttons + '</div>';
                    }, this)
                }
            ]
        });
    },
    addClicked: function () {
        this.editProvider(new PJQ.models.sso.Provider({
            isDefault: _.size(this.collection.models) === 0
        }));
    },
    editClicked: function (e) {
        let target = $(e.currentTarget),
            row = this.dataTable.getRow(target.closest('tr')),
            note = row.data();
        this.editProvider(note);
    },
    deleteClicked: function (e) {
        let target = $(e.currentTarget),
            row = this.dataTable.getRow(target.closest('tr'));
        this.deleteProvider(row);
    },
    editProvider: function (provider) {
        let isNew = provider.isNew();
        new PJQ.views.settings.EditSSOProviderModal({
            model: provider,
            onSave: _.bind(function () {
                if (isNew) {
                    this.collection.add(provider);
                }
                this.render();
            }, this),
            onDelete: _.bind(function (provider) {
                if (!isNew) {
                    this.collection.remove(provider);
                    this.render();
                }
            }, this)
        });
    },
    deleteProvider: function (row) {
        let provider = row.data();
        new PJQ.views.modals.DeleteCancel({
            header: "Confirm Deletion",
            body: "Are you sure you want to delete this provider?",
            onDelete: _.bind(function () {
                this.collection.remove(provider);
                provider.destroy();
                this.dataTable.removeRow(row);
            }, this)
        });
    }
});

PJQ.views.settings.EditSSOProviderModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.SETTINGS, 'modal-sso'),
        minWidth: 600,
        onSave: null,
        isUpdatingCertificate: false
    },
    defaultEvents: {
        'change .cb-enable-provisioning': 'provisioningChanged',
        'click .btn-refresh-provisioning-token': 'refreshProvisioningToken',
        'click .btn-update-certificate': 'updateCertificate',
        'click .btn-save': 'save',
        'click .btn-cancel': 'cancel',
        'click .btn-delete': 'delete'
    },
    beforeModalCreated: function () {
        if (this.model == null) {
            this.model = new PJQ.models.sso.Provider({
                isDefault: false,
                provider: PJQ.constants.sso.providers.AZURE_AD
            });
        }

        if (_.size(this.model.get('provider')) === 0) {
            this.model.set('provider', PJQ.constants.sso.providers.AZURE_AD);
        }
    },
    renderData: function () {
        return {
            model: this.model,
            options: this.options
        };
    },
    afterRender: function () {
        new PJQ.Binder(this.$el, this.model, {
            watchElements: [
                'input',
                'textarea'
            ]
        });

        new PJQ.inputs.Selectpicker({
            el: this.$('.select-provider'),
            hideDisabled: true,
            defaultValue: this.model.get('provider'),
            onChange: _.bind(function (value) {
                this.model.set('provider', value);
                this.render();
            }, this)
        });
    },
    provisioningChanged: function (e) {
        let provisioningEnabled = $(e.currentTarget).prop('checked');
        this.model.set('disableProvisioning', !provisioningEnabled);
        if (provisioningEnabled && _.size(this.model.get('provisioningToken')) === 0) {
            this.model.refreshProvisioningToken(_.bind(function () {
                this.render();
            }, this));
        } else {
            this.render();
        }
    },
    refreshProvisioningToken: function () {
        new PJQ.views.modals.YesNo({
            header: "Confirm Authentication Token Refresh",
            body: 'Are you sure you want to generate a new authentication token?  This action cannot be reversed.',
            onYes: _.bind(function () {
                new PJQ.Loader(this.$('.provisioning-token-outer'));
                this.model.refreshProvisioningToken(_.bind(function () {
                    PJQ.notifications.notify.successNotify({
                        message: 'Provisioning token successfully refreshed'
                    });
                    this.render();
                }, this));
            }, this)
        });
    },
    updateCertificate: function () {
        this.options.isUpdatingCertificate = true;
        this.render();
    },
    validate: function(){
        let isValid = true;

        let isSignOnUrlValid =_.size(this.model.get('issuer')) > 0;
        PJQ.helpers.inputHelpers.setInputError(this.$('.input-sign-on-url'), isSignOnUrlValid);
        isValid = isValid && isSignOnUrlValid;

        let isIssuerValid =_.size(this.model.get('issuer')) > 0;
        PJQ.helpers.inputHelpers.setInputError(this.$('.input-issuer'), isIssuerValid);
        isValid = isValid && isIssuerValid;

        if(this.options.isUpdatingCertificate || this.model.isNew()){
            let isCertificateValid =_.size(this.model.get('certificate')) > 0;
            PJQ.helpers.inputHelpers.setInputError(this.$('.input-certificate'), isCertificateValid);
            isValid = isValid && isCertificateValid;
        }

        if(!isValid) {
            if (this.errorAlert != null) {
                this.errorAlert.destroy();
            }
            this.errorAlert = new PJQ.Alert(this.$('.error-container'), {
                type: 'danger',
                text: 'Required fields missing data'
            });
        }

        return isValid;
    },
    save: function () {
        if(!this.validate()){
            return;
        }

        this.model.save(null, {
            success: _.bind(function () {
                PJQ.notifications.notify.successNotify({
                    message: 'SSO provider successfully created'
                });
                this.removeModal();
                if (typeof this.options.onSave === 'function') {
                    this.options.onSave(this.model);
                }
            }, this)
        })
    },
    cancel: function () {
        this.model.restore();
        this.removeModal();
    },
    delete: function () {
        new PJQ.views.modals.DeleteCancel({
            header: "Confirm Deletion",
            body: "Are you sure you want to delete this provider?",
            onDelete: _.bind(function () {
                this.model.destroy();
                this.removeModal();
                if (typeof this.options.onDelete === 'function') {
                    this.options.onDelete(this.model);
                }
            }, this)
        });
    }
});